module.exports = __webpack_public_path__ + "media/2020-1923.ba0f1cc7.mp4";